import { type VariantProps, cva } from "class-variance-authority";

export const toast = cva("w-[656px] rounded-alert-rounding-default border px-2 shadow-4", {
  variants: {
    variant: {
      outlined: "border text-text-inverted-1",
      contained: "text-text-default-1",
    },
    color: {
      neutral: "border-elevation-outline-default-1 bg-elevation-fill-default-1",
      success: "border-success bg-success-75",
      warning: "border-warning bg-secondary-300",
      error: "border-danger bg-secondary-300",
    },
    position: {
      "bottom-right": "mb-8",
      "bottom-left": "mb-8",
      "bottom-center": "mb-8",
      "top-right": "mt-8",
      "top-left": "mt-8",
      "top-center": "mt-8",
    },
  },
  compoundVariants: [
    {
      variant: "outlined",
      color: "neutral",
      className: "border-elevation-outline-default-1 text-text-default-1!",
    },
    {
      variant: "outlined",
      color: "success",
      className: "border-elevation-outline-success-1 text-success!",
    },
    {
      variant: "outlined",
      color: "warning",
      className: "border-elevation-outline-warning-1",
    },
    {
      variant: "outlined",
      color: "error",
      className: "border-elevation-outline-error-1",
    },
    {
      variant: "contained",
      color: "neutral",
      className: "bg-elevation-fill-inverted-1 text-text-inverted-1",
    },
    {
      variant: "contained",
      color: "success",
      className: "bg-elevation-fill-success-1 text-text-inverted-1",
    },
    {
      variant: "contained",
      color: "warning",
      className: "bg-elevation-fill-warning-1",
    },
    {
      variant: "contained",
      color: "error",
      className: "bg-elevation-fill-error-1",
    },
  ],
  defaultVariants: {
    variant: "contained",
    color: "neutral",
  },
});

export interface ToastVariantProps extends VariantProps<typeof toast> {}

export const iconCva = cva("mr-3 h-6 w-6 shrink-0", {
  variants: {
    color: {
      neutral: "text-secondary-50",
      success: "text-success",
      warning: "text-warning",
      error: "text-danger",
    },
  },
  defaultVariants: {
    color: "neutral",
  },
});
